import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const NavList = styled.ul<Props>`
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
`;

export const NavLink = styled(Link)<Props>`
  font-size: 15px;
  letter-spacing: 0;
  line-height: 21px;
  text-decoration: none;
  color: ${(props: Props) => props.theme.palette.neutral._80};
  display: flex;

  &:after {
    content: "|";
    color: #b4c2e2;
    padding: 0 10px;
  }

  &:last-child:after {
    content: "";
  }
`;
